import React, { useContext, useState, useMemo } from 'react';
import { Collapse } from 'antd';
import {
  Widget,
  usePromise,
  CrudContext,
  MasterDetailForm,
  FormInput,
  Button,
  ButtonDelete, Col, notification
} from '@digital/ui';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  PlanilhaRateioCommandResult,
  getRateioByMedicaoId,
  getRateioBmTotvsByMedicaoId,
  BmTotvs,
  getPlanilhaRateioBmByMedicaoId,
  DadosRateio,
  getAllTipoLinhaPlanilhaRateioOptions,
  updateLinhaPlanilhaRateioMatriz,
  creatNovaPlanilha,
  creatNovaPlanilhaRateioErdadaBmAnterior,
  deletePlanilhaRateio,
  creatNewLinePlanilha,
  deleteLinePlanilha,
  enviarParaTotvs,
  LinhaItemRateavelBmResult,
  updateLinhaItemRateioValor,
  LinhaPlanilhaTotais,
  downloadModelo,
  ExportarPlanilhaRateio
} from '@app/api/planilhaRateio';
import { Icon, Table as TableAntd, Select, InputNumber, Input } from 'antd';
import { hasPermission } from '@app/helpers/permissions';
import { getValorADistribuirPorTipoDocumento, ResumoMedicaoList } from '@app/api/boletimMedicao';
import CurrencyInput2 from '@app/components/CurrencyInput2';
import { currencyFormat, thousandSeparator } from '@app/helpers/numbers';
import FormNovaPlanilha from './formNovaPlanilha';
import FormImportarPlanilha from './formImportarPlanilha';
import { getAllTipoDocumentoCobrancaByMedicaoOptions } from '@app/api/contrato/planilhaQuantidadeContrato';
import { getAllMunicipiosOptionsByMedicaoId } from '@app/api/municipio';
import ModalJustificativaVoltarRateioPendente from './ModalJustificativaVoltarRateioPendente';
import { useRecoilState } from 'recoil';
import { medicaoSelectedState } from '../atoms';

interface AbaRateioProps {
  medicaoSelecionada: ResumoMedicaoList;
  onUpdatePage: () => any;
}

const AbaRateio = (props: AbaRateioProps) => {
  const { onUpdatePage } = props;
  const [planilhasServicos, setPlanilhasServicos] = useState({});
  const [medicaoSelected, setMedicaoSelected] = useRecoilState(medicaoSelectedState);
  const { Panel } = Collapse;
  const [tipoLinhaPlanilhaRateio, setTipoLinhaPlanilhaRateio] = useState<any[]>([]);
  const [atualizarTabelaTotvs, setAtualizarTabelaTotvs] = useState<boolean>(false);
  const [atualizarPlanilhaRateio, setAtualizarPlanilhaRateio] = useState<boolean>(false);
  const [atualizarMatrizServicos, setAtualizarMatrizServicos] = useState<boolean>(false);
  const [atualizarValorInicial, setAtualizarValorInicial] = useState<boolean>(false);
  const [dadosIniciais, setDadosIniciais] = useState<DadosRateio>();
  const [totalValorBmTotvs, setTotalValorBmTotvs] = useState();
  const [tipoDocumentoCobrancaOptions, setTipoDocumentoCobrancaOptions] = useState([{}]);
  const [municipiosOptions, setMunicipiosOptions] = useState([{}]);
  const [valoresADistribuir, setValoresADistribuir] = useState<any>({});

  const formatReal = (valor: string) => {
    let tmp = valor + '';
    tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
    tmp = tmp.replace('.,', ',');
    if (tmp.length > 6) {
      tmp = tmp.replace(/(\d)(?=(\d{3})+\,)/g, '$1.');
    }
    return tmp;
  };

  const saveValor = (record: LinhaItemRateavelBmResult) => {
    updateLinhaItemRateioValor(record.id, record.valor).then(data => {
      if (data.updatePlanilhas) {
        location.reload();
        return;
      }
      if (data === true) return;
      setPlanilhasServicos({ ...planilhasServicos });
    });
  };

  const saveLinhaPlanilha = (record: any) => {
    updateLinhaPlanilhaRateioMatriz(record).then(data => {
      if (data.id) {
        record.unsaved = false;
        setPlanilhasServicos({ ...planilhasServicos });
      }
    });
  };

  const deleteLinhaPlanilha = (record: any, planilhaId: string) => {
    deleteLinePlanilha(record.id).then(data => {
      const planilhas = { ...planilhasServicos };
      for (const [key, value] of Object.entries(planilhasServicos)) {
        value.planilhas.map(planilha => {
          if (planilha.id === planilhaId) {
            planilha.linhaPlanilhaRateioResult = planilha.linhaPlanilhaRateioResult.filter(e => e.id !== record.id);
          }
        });
      }
      setPlanilhasServicos(planilhas);
    });
  };

  useMemo(async () => {
    for (const [key, value] of Object.entries(planilhasServicos)) {
      if (value.valorADistribuir === undefined && key != "undefined") {
        let result = await getValorADistribuirPorTipoDocumento({ medicaoId: medicaoSelected.id, tipoDocumentoCobrancaId: key });
        if (value.valorADistribuir !== currencyFormat(result.valorADistribuir)) {
          value.valorADistribuir = currencyFormat(result.valorADistribuir);
          setPlanilhasServicos({ ...planilhasServicos });
        }
      }
    }
  }, [planilhasServicos]);

  let [dataBmTotv] = usePromise(
    () => (medicaoSelected ? getRateioBmTotvsByMedicaoId(medicaoSelected.id) : Promise.resolve(undefined)),
    [medicaoSelected, atualizarTabelaTotvs],
    [] as BmTotvs[],
  );

  const CallbackImportarPlanilha = () => {
    setAtualizarPlanilhaRateio(!atualizarPlanilhaRateio);
  };

  useMemo(() => {
    const initialValuesUpdate = dadosIniciais;
    let valorRatearGlobal = dadosIniciais ? dadosIniciais.valorBmNumber : 0;
    let valorCcGlobal = 0;
    let valorOiGlobal = 0;
    let valorOmGlobal = 0;
    let valorCrGlobal = 0;
    let valorTotalGlobal = 0;
    let valorADistribuir = dadosIniciais ? dadosIniciais.valorBmNumber : 0;

    let planilhaIndex = 1;
    if (Object.keys(planilhasServicos).length > 0 && planilhasServicos.constructor === Object && dadosIniciais && dataBmTotv) {
      dadosIniciais.planilhaTotais = {
        linhas: [],
        somaAcumulado: 0,
        somaAnterior: 0,
        somaMedicao: 0,
        somaSaldo: 0,
        somaTotal: 0
      };
      dataBmTotv.map((bm, index) => {
        let linha: LinhaPlanilhaTotais = {
          bmTotvs: bm,
          index: index,
          saldo: 0,
          valorAcumulado: 0,
          valorMedicao: 0,
        };
        dadosIniciais.planilhaTotais.linhas.push(linha);
      });

      const planilhasUpdate = planilhasServicos;
      for (const [key, value] of Object.entries(planilhasUpdate)) {
        value.planilhas.forEach(planilha => {
          planilha.total = 0;
          planilha.totalARatear = 0;
          planilha.totalCc = 0;
          planilha.totalOi = 0;
          planilha.totalOm = 0;
          planilha.totalCr = 0;
          planilha.numero = planilhaIndex;
          planilhaIndex++;
          let linhaIndex = 1;
          planilha.linhaItemRateavelBmPlanilhaRateioResult.forEach(linha => {
            if (linha.valor) {
              valorADistribuir -= linha.valor;
              planilha.total += linha.valor;
            }
            dadosIniciais.planilhaTotais.linhas.map(linhaTotal => {
              if (linhaTotal.bmTotvs.item === linha.bmItemNumero) {
                if (linha.valor) linhaTotal.valorMedicao += linha.valor;
                linha.index = linhaTotal.index + 1;
              }
            });
          });
          planilha.linhaPlanilhaRateioResult.forEach(linha => {
            if (linha.valor) {
              if (linha.tipoCodigo === 1) planilha.totalOi += linha.valor;
              if (linha.tipoCodigo === 2) planilha.totalCc += linha.valor;
              if (linha.tipoCodigo === 3) planilha.totalOm += linha.valor;
              if (linha.tipoCodigo === 4) planilha.totalCr += linha.valor;
            }
            linha.index = linhaIndex;
            linhaIndex++;
          });
          planilha.totalRateio = planilha.totalCc + planilha.totalOi + planilha.totalOm + planilha.totalCr;
          planilha.totalARatear = planilha.total - planilha.totalRateio;
          planilha.totalFormatado = currencyFormat(planilha.total);
          valorCcGlobal += planilha.totalCc;
          valorOiGlobal += planilha.totalOi;
          valorOmGlobal += planilha.totalOm;
          valorCrGlobal += planilha.totalCr;
          valorRatearGlobal -= planilha.totalRateio;
          planilha.linhaItemRateavelBmPlanilhaRateioResult.sort((a: any, b: any) => a.index - b.index);
        });
      }
      valorTotalGlobal = valorCcGlobal + valorOiGlobal + valorOmGlobal;
      initialValuesUpdate.valorCc = currencyFormat(valorCcGlobal);
      initialValuesUpdate.valorOi = currencyFormat(valorOiGlobal);
      initialValuesUpdate.valorOm = currencyFormat(valorOmGlobal);
      initialValuesUpdate.valorCr = currencyFormat(valorCrGlobal);
      initialValuesUpdate.valorReatear = currencyFormat(valorRatearGlobal);
      initialValuesUpdate.valorTotalFormatado = currencyFormat(valorTotalGlobal);
      initialValuesUpdate.valorADistribuir = currencyFormat(valorADistribuir);

      dadosIniciais.planilhaTotais.linhas.map((linha, index) => {
        linha.valorAcumulado = linha.valorMedicao + linha.bmTotvs.anterior;
        linha.saldo = linha.bmTotvs.valorTotal - linha.valorAcumulado;
        dadosIniciais.planilhaTotais.somaMedicao += linha.valorMedicao;
        dadosIniciais.planilhaTotais.somaAcumulado += linha.valorAcumulado;
        dadosIniciais.planilhaTotais.somaSaldo += linha.saldo;
        dadosIniciais.planilhaTotais.somaAnterior += linha.bmTotvs.anterior;
        dadosIniciais.planilhaTotais.somaTotal += linha.bmTotvs.valorTotal;
      });
      setDadosIniciais(initialValuesUpdate);
      setPlanilhasServicos(planilhasUpdate);
    }
  }, [planilhasServicos, dataBmTotv]);

  const renderMatrizServicos = (planilha: PlanilhaRateioCommandResult) => {
    let columns = [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'Descricao',
        dataIndex: 'descricao',
        width: '70%',
      },
      {
        title: 'Valor',
        children: [
          {
            title: () => {
              return currencyFormat(planilha.total);
            },
            dataIndex: 'valor',
            render: (text, record, index) => {
              return <CurrencyInput2 name='valor' defaultValue={record.valor} onChange={(e) => { record.valor = e; }} onKeyDown={e => { if (e.key === 'Enter') saveValor(record); }} disabled={planilha.statusCodigo == 4 || planilha.statusCodigo == 5} />;
            }
          }
        ],
        width: '30%',
      }
    ];

    return (
      <>
        <TableAntd key={planilha.id}
          columns={columns}
          dataSource={planilha.linhaItemRateavelBmPlanilhaRateioResult}
          rowKey={'id'}
          pagination={false}
        />
      </>
    );
  };

  const renderMatrizRateio = (planilha: PlanilhaRateioCommandResult) => {
    let columns = [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'Tipo',
        dataIndex: 'oiOuCc',
        width: '25%',
        render: (text, record, index) => {
          return (
            <Select
              defaultValue={record.oiOuCc}
              onChange={e => {
                const el = tipoLinhaPlanilhaRateio.find(ele => ele.value === e);
                record.tipoCodigo = el.codigo;
                record.tipoNome = el.text;
                record.oiOuCc = e;

                record.numero = null;
                record.natureza = null;
                record.unsaved = true;

                setPlanilhasServicos({ ...planilhasServicos });


              }}
              style={{ width: '100%' }}
              disabled={planilha.statusCodigo == 4}
            >
              {
                tipoLinhaPlanilhaRateio.map(el => {
                  return (<Option value={el.value}>{el.text}</Option>);
                })
              }
            </Select>);
        }
      },
      {
        title: 'Natureza',
        dataIndex: 'natureza',
        width: '25%',
        render: (text, record, index) => {
          return <InputNumber maxLength={9} name='natureza' value={record.natureza} onChange={(e) => { record.natureza = e; record.unsaved = true; }} onBlur={() => setPlanilhasServicos({ ...planilhasServicos })} onKeyDown={e => { if (e.key === 'Enter') saveLinhaPlanilha(record); }} disabled={planilha.statusCodigo == 4} />;
        }
      },
      {
        title: 'Número',
        dataIndex: 'numero',
        width: '25%',
        render: (text, record, index) => {
          return <InputNumber maxLength={9} name='numero' value={record.numero} onChange={(e) => { record.numero = e; record.unsaved = true; }} onBlur={() => setPlanilhasServicos({ ...planilhasServicos })} onKeyDown={e => { if (e.key === 'Enter') saveLinhaPlanilha(record); }} disabled={planilha.statusCodigo == 4 || record.tipoCodigo == 4} />;
        }
      },
      {
        title: 'Valor',
        dataIndex: 'valor',
        render: (text, record, index) => {
          return <CurrencyInput2 name='valor' value={record.valor} onChange={(e) => { record.valor = e; }} onBlur={(e) => { if (e.target.value != thousandSeparator(record.valor)) record.unsaved = true; setPlanilhasServicos({ ...planilhasServicos }); }} onKeyDown={e => { if (e.key === 'Enter') saveLinhaPlanilha(record); }} disabled={planilha.statusCodigo == 4} />;
        },
        width: '25%',
      },
      {
        title: 'Ações',
        width: '1%',
        render: (text, record, index) => {
          return <Button confirm="Deseja realmente excluir este registro?" okText="Confirmar" onClick={e => { deleteLinhaPlanilha(record, planilha.id); }} style={{ cursor: 'pointer' }} disabled={planilha.statusCodigo == 4} ><Icon type="delete" /> </Button>;
        }
      }
    ];

    return (
      <>
        <TableAntd key={`planilha-rateio_${planilha.id}`}
          rowClassName={(record, index) => record.unsaved ? 'table-row-dark' : 'table-row-light'}
          columns={columns}
          dataSource={planilha.linhaPlanilhaRateioResult}
          rowKey={'id'}
          pagination={false}
        />
      </>
    );
  };

  const renderMatrizTotais = () => {
    let columns = [
      {
        title: 'Item',
        dataIndex: 'index',
        width: '1%',
        render: (text, record, index) => { return (record.index + 1); }
      },
      {
        title: 'Descrição',
        dataIndex: 'bmTotvs.descricao',
        width: '40%'
      },
      {
        title: 'UN',
        dataIndex: 'bmTotvs.unidade',
        width: '1%'
      },
      {
        title: 'Valor Total',
        children: [
          {
            title: () => { return currencyFormat(dadosIniciais.planilhaTotais.somaTotal); },
            render: (text, record, index) => { return currencyFormat(record.bmTotvs.valorTotal); }
            width: '15%',
          }
        ]
      },
      {
        title: 'Anterior',
        children: [
          {
            title: () => { return currencyFormat(dadosIniciais.planilhaTotais.somaAnterior); },
            render: (text, record, index) => { return currencyFormat(record.bmTotvs.anterior); }
            width: '15%',
          }
        ]
      },
      {
        title: 'Valor Medição',
        children: [
          {
            title: () => { return currencyFormat(dadosIniciais.planilhaTotais.somaMedicao); },
            render: (text, record, index) => { return currencyFormat(record.valorMedicao); },
            width: '15%'
          }
        ]
      },
      {
        title: 'Acumulado',
        children: [
          {
            title: () => { return currencyFormat(dadosIniciais.planilhaTotais.somaAcumulado); },
            render: (text, record, index) => { return currencyFormat(record.valorAcumulado); },
            width: '15%',
          }
        ]
      },
      {
        title: 'Saldo',
        children: [
          {
            title: () => { return currencyFormat(dadosIniciais.planilhaTotais.somaSaldo); },
            render: (text, record, index) => { return currencyFormat(record.saldo); },
            width: '15%',
          }
        ]
      }

    ];

    if (dadosIniciais) {
      if (dadosIniciais.planilhaTotais) {
        return (
          <>
            <TableAntd
              columns={columns}
              dataSource={dadosIniciais.planilhaTotais.linhas}
              rowKey={'bmTotvs.id'}
              pagination={false}
            />
          </>
        );
      } else return null;
    } else return null;
  };

  const renderPlanilhas = (planilhas: PlanilhaRateioCommandResult[]) => {
    return (
      <>
        {planilhas.map((planilha: PlanilhaRateioCommandResult) => {
          return (<>
            <Widget
              style={{ border: 'solid 1px gray', marginTop: '15px', paddingLeft: '5px', paddingRight: '5px' }}
              key={`planilha${planilha.id}`} title={`Rateio ${planilha.numero} - ${planilha.municipioNome} - ${planilha.totalFormatado} - ${planilha.status} ${medicaoSelected.pisCofins ? planilha.pisCofins ? '- Com crédito PIS/COFINS' : '- Sem crédito PIS/COFINS' : ''}`}
              actions={[
                <>
                  {(hasPermission(['PLANILHA_RATEIO_CADASTRAR_PLANILHA'])) && planilha.statusCodigo != 4 && planilha.statusCodigo != 5 ? (
                    <>
                      <ButtonDelete  
                        icon={null}
                        type="link"
                        confirm="Deseja realmente excluir este registro?"
                        okText="Confirmar"
                        onClick={() => {
                          if (hasPermission(['PLANILHA_RATEIO_CADASTRAR_PLANILHA'])) {
                            deletePlanilhaRateio(planilha.id).then((data) => {
                              setAtualizarPlanilhaRateio(!atualizarPlanilhaRateio);
                              setAtualizarValorInicial(!atualizarValorInicial);
                            });
                          }
                        }}>
                        Excluir Rateio
                      </ButtonDelete>
                      <FormImportarPlanilha planilhaRateioId={planilha.id} CallbackImportarPlanilha={CallbackImportarPlanilha} />
                    </>
                  ) : (<> </>)}
                  {(hasPermission(['PLANILHA_RATEIO_CADASTRAR_PLANILHA'])) ? (
                    <>
                      <Button
                        type="link"
                        icon="files-ms_excel"
                        onClick={() => {
                          ExportarPlanilhaRateio(planilha.id);
                        }}>
                        Exportar Rateio
                      </Button>

                    </>
                  ) : (<> </>)}
                </>
              ]}>
              <Widget title={'Matriz de Serviços'} style={{ border: 'solid 1px gray' }} >
                <PerfectScrollbar>
                  {renderMatrizServicos(planilha)}
                </PerfectScrollbar>
              </Widget>
              <Widget title={'Matriz de Rateio'} style={{ border: 'solid 1px gray', marginTop: '15px', paddingLeft: '5px', paddingRight: '5px' }}
                actions={[
                  (planilha.statusCodigo != 4) ?
                    (<Button
                      type="link"
                      icon="data-add_row"
                      size="small"
                      onClick={(e) => {
                        creatNewLinePlanilha(planilha.id).then((data) => {
                          setAtualizarPlanilhaRateio(!atualizarPlanilhaRateio);
                          setAtualizarValorInicial(!atualizarValorInicial);
                        });
                      }}>
                      Incluir linha
                    </Button>) : (<> </>)
                ]}>
                <div className={'ant-row'}>
                  <MasterDetailForm>
                    <div className={'ant-row'}>
                      <FormInput label="Valor à ratear" value={currencyFormat(planilha.totalARatear)} name="totalARatear" span={3} disabled={true} />
                    </div>
                    <div className={'ant-row'}>
                      <FormInput label="Valor CC" value={currencyFormat(planilha.totalCc)} name="totalCc" span={3} disabled={true} />
                      <FormInput label="Valor OI" value={currencyFormat(planilha.totalOi)} name="TotalOi" span={3} disabled={true} />
                      <FormInput label="Valor OM" value={currencyFormat(planilha.totalOm)} name="TotalOm" span={3} disabled={true} />
                      <FormInput label="Valor CR" value={currencyFormat(planilha.totalCr)} name="TotalCr" span={3} disabled={true} />
                      <FormInput label="Valor Total" value={currencyFormat(planilha.totalRateio)} name="TotalRateio" span={3} disabled={true} />
                    </div>
                  </MasterDetailForm>
                </div>
                <PerfectScrollbar>
                  {renderMatrizRateio(planilha)}
                </PerfectScrollbar>
              </Widget>
            </Widget>
          </>);
        })
        }
      </>
    );
  };

  const renderSuperGrupos = () => {
    const renderedElement = [];
    for (const [key, value] of Object.entries(planilhasServicos)) {
      renderedElement.push(
        <Collapse
          bordered={false}
          expandIcon={() => <Icon type="arrows-right_4" />} >
          <Panel
            key={value.tipoDocumentoCobrancaNome}
            header={`RATEIO(S) - ${value.tipoDocumentoCobrancaNome}`}>
            <Col span={3}>
              <Input value={value.valorADistribuir} disabled />
            </Col>
            {renderPlanilhas(value.planilhas)}
          </Panel>
        </Collapse>);
    }
    return (<>{renderedElement}</>);
  };

  const planilhasResult = useMemo(async () => {
    if (medicaoSelected) {
      const result = await getPlanilhaRateioBmByMedicaoId(medicaoSelected.id);
      const rateio = await getRateioByMedicaoId(medicaoSelected.id);
      const tipos = await getAllTipoLinhaPlanilhaRateioOptions();
      const municipios = await getAllMunicipiosOptionsByMedicaoId(medicaoSelected.id);
      const tiposDocumento = await getAllTipoDocumentoCobrancaByMedicaoOptions(medicaoSelected.id);
      if (result) {
        var planilhas = {};
        result.forEach(planilha => {
          if (!planilhas[planilha.tipoDocumentoCobrancaId]) {
            planilhas[planilha.tipoDocumentoCobrancaId] = { 'planilhas': [], 'tipoDocumentoCobrancaNome': '' };
          }
          planilhas[planilha.tipoDocumentoCobrancaId].tipoDocumentoCobrancaNome = planilha.tipoDocumentoCobrancaNome;
          planilhas[planilha.tipoDocumentoCobrancaId]['planilhas'].push(planilha);
        });
        setPlanilhasServicos({ ...planilhas });
      }
      if (rateio) {
        setTotalValorBmTotvs(rateio.valorTotaItemRateavelBm);
      }
      if (tipos) {
        setTipoLinhaPlanilhaRateio(tipos);
      }
      if (municipios) {
        setMunicipiosOptions(municipios);
      }
      if (tiposDocumento) {
        setTipoDocumentoCobrancaOptions(tiposDocumento);
      }
    }
  }, [medicaoSelected, atualizarPlanilhaRateio, atualizarValorInicial]);

  const valorInicial = useMemo(() => {
    if (medicaoSelected) {
      getRateioByMedicaoId(medicaoSelected.id).then((data) => { setDadosIniciais(data as DadosRateio); });
    }
  }, [medicaoSelected, atualizarValorInicial]);

  const creatNewPlanilhaRateio = () => {
    setAtualizarPlanilhaRateio(!atualizarPlanilhaRateio);
  };

  return (
    <>
      <Collapse
        bordered={false}
        expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="dadosRateio" header={'Dados de Rateio'} style={{ border: 0 }}>
          <MasterDetailForm initialValues={dadosIniciais}>
            <Widget actions={[
              <>
                {
                  dadosIniciais ? ((
                    dadosIniciais.statusCodigo != 1 && hasPermission(['PLANILHA_RATEIO_VOLTAR_RATEIO']) ? (
                      <ModalJustificativaVoltarRateioPendente id={dadosIniciais.id} onUpdatePage={onUpdatePage} />
                    ) : (<> </>)
                  )
                  ) : (<> </>)
                }
              </>,
              <>
                <Button
                  id="btnDonwloadModelo"
                  icon="files-xls"
                  type='link'
                  onClick={() => {
                    downloadModelo();
                  }}>
                  Modelo de Importação</Button>
              </>,
              <>
                {dadosIniciais ? (
                  (hasPermission(['PLANILHA_RATEIO_CADASTRAR_PLANILHA']) && dadosIniciais.statusCodigo != 4 && dadosIniciais.statusCodigo != 5 ? (
                    <FormNovaPlanilha
                      tipoDocumentoCobrancaOptions={tipoDocumentoCobrancaOptions}
                      municipiosOptions={municipiosOptions}
                      medicaoId={medicaoSelected.id}
                      pisCofinsContrato={medicaoSelected.pisCofins}
                      CallbackNovaPlanilha={() => {
                        creatNewPlanilhaRateio();
                      }}
                    />
                  ) : (<> </>)
                  )
                ) : (<> </>)
                }
              </>,
              <>
                {
                  dadosIniciais ? (
                    (hasPermission(['PLANILHA_RATEIO_INTEGRAR_COM_TOTVS']) && dadosIniciais.statusCodigo != 4 ? (
                      <Button
                        id={'btnEviarParaTotvs'}
                        type="primary"
                        icon="data-data_in_both_directions"
                        size="small"
                        onClick={() => {
                          if (medicaoSelected) {
                            let editando = false;
                            for (const [key, value] of Object.entries(planilhasServicos)) {
                              value.planilhas.map(planilha => {
                                planilha.linhaPlanilhaRateioResult.map(linha => {
                                  if (linha.unsaved) {
                                    notification.error("ERRO-SGC: Existem linhas não salvas no rateio " + planilha.numero + ".");
                                    editando = true;
                                  }
                                });
                              });
                            }
                            if (!editando) {
                              enviarParaTotvs(medicaoSelected.id).then((data) => {
                                if (data) {
                                  if (data.valid) {
                                    location.reload();
                                  } else {
                                    setAtualizarValorInicial(!atualizarValorInicial);
                                    setAtualizarPlanilhaRateio(!atualizarPlanilhaRateio);
                                  }
                                } else {
                                  setAtualizarValorInicial(!atualizarValorInicial);
                                  setAtualizarPlanilhaRateio(!atualizarPlanilhaRateio);
                                }
                              });
                            }
                          }
                        }}>
                        ENVIAR PARA O TOTVS
                      </Button>
                    ) : (<> </>)
                    )
                  ) : ('<> </>')
                }
              </>

            ]}>

              <FormInput label="Status" name="status" span={3} disabled={true} />
              <FormInput label="Valor do BM" name="valorBm" span={3} disabled={true} />
              <FormInput label="Valor à distribuir" name="valorADistribuir" span={3} disabled={true} />
              <FormInput label="Valor à ratear" name="valorReatear" span={3} disabled={true} />
              <FormInput label="Valor CC" name="valorCc" span={3} disabled={true} />
              <FormInput label="Valor OI" name="valorOi" span={3} disabled={true} />
              <FormInput label="Valor OM" name="valorOm" span={3} disabled={true} />
              <FormInput label="Valor CR" name="valorCr" span={3} disabled={true} />
              <FormInput label="Valor Total" name="valorTotalFormatado" span={3} disabled={true} />

              <FormInput name="aditivoVigenteDataCriacaoBmString" label="Aditivo TOTVS vigente na data de criação do BM" span={3} disabled={true} />
              <FormInput name="aditivoVigenteAtualString" label="Aditivo vigente na data atual" span={3} disabled={true} />

              {renderMatrizTotais()}

            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
      {
        Object.keys(planilhasServicos).length > 0 ? (
          <>
            {renderSuperGrupos()}
          </>
        ) : null}
    </>
  );
};
export default AbaRateio;
